import { faRocket } from "@fortawesome/pro-regular-svg-icons";

import { Pill } from "src/design-system/Pill";
import { Tooltip, TooltipProps } from "src/design-system/Tooltip";
import { FEATURE_FLAGS, isFeatureFlagEnabled } from "src/router/featureFlags";

type BetaPillProps = Omit<TooltipProps, "children">;

export const BetaPill: React.FC<BetaPillProps> = ({
  title = "Beta feature 🎉",
  body = BETA_PILL_BODY_TEXTS.feature,
  ...props
}) => {
  if (isFeatureFlagEnabled(FEATURE_FLAGS.hideBetaPills)) {
    return null;
  }

  return (
    <Tooltip body={body} title={title} {...props}>
      <Pill size="sm">
        <Pill.Icon icon={faRocket} />
        <Pill.Text>Beta</Pill.Text>
      </Pill>
    </Tooltip>
  );
};

export const BETA_PILL_BODY_TEXTS = {
  feature:
    "This feature has been recently developed and your feedback is crucial as we continue to refine our products to better serve your needs.",
  connection:
    "This connection has been recently integrated and your feedback is crucial as we continue to refine our products to better serve your needs.",
};
